import {storage} from "utils"

export const storagekey = "mcs.host.urls.api"
export const front_storagekey = "mcs.host.urls.front"

export namespace config {
    export function api_version(): string {
        return storage.load(storagekey, window.env?.REACT_APP_MCS_API_VERSION || "v1")
    }

    export function host(): string {
        // TODO default to production host
        return storage.load(storagekey, window.env?.REACT_APP_MCS_API_HTTP_ENDPOINT || "https://localhost:3001")
    }

    export function baseApiUrl(): string {
        return host() + "/" + api_version()
    }

    export function publicUrl(): string {
        return storage.load(storagekey, window.env?.PUBLIC_URL || "https://localhost:3000")
    }

    export function wshost(): string {
        return storage.load(storagekey, window.env?.REACT_APP_MCS_API_HTTP_ENDPOINT || "https://localhost:3001").replace(
            "https://",
            "wss://",
        )
    }

    export function frontend_host(): string {
        return storage.load(front_storagekey, window.env?.REACT_APP_MCS_CONSOLE_HTTP_ENDPOINT || "https://localhost:3000")
    }
}
